export default function CrossIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.974 6.436L17.565 5.026L12 10.59L6.411 5L5 6.41L10.59 12L5 17.59L6.411 19L12 13.41L17.59 19L19 17.59L13.411 12L18.974 6.436Z"
        fill="currentColor"
      />
    </svg>
  );
}
